// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".close-icon[data-v-848bc07e]{cursor:pointer;height:1.25rem;transition-duration:.15s}.close-icon[data-v-848bc07e]:hover{opacity:.5}.cancel[data-v-848bc07e]{--tw-text-opacity:1;color:#b8c2cc;color:rgb(184 194 204/var(--tw-text-opacity));cursor:pointer;font-weight:600;transition-duration:.15s}.cancel[data-v-848bc07e]:hover{--tw-text-opacity:1;color:#f1832f;color:rgb(241 131 47/var(--tw-text-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
